import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'
import PlusMinusButtonChanger from 'components/WorkoutTemplateBuilder/Components/PlusMinusButtonChanger'

export default function ExerciseSetsButton({ phase, phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    switch (mode) {
        // Edit Mode
        case 'edit':
            switch (phase.type) {
                // Straight Phase Type
                case 'straight':
                    return (
                        <div className="h-10 flex justify-center w-40 border-l px-4 border-stone-400 items-center">
                            <PlusMinusButtonChanger
                                label="Sets:"
                                value={exercise.sets.length}
                                handleAddFunction={() => mutateExercise('add-set', phaseIndex, exerciseIndex)}
                                handleSubtractFunction={() => mutateExercise('subtract-set', phaseIndex, exerciseIndex)}
                            />
                        </div>
                    )

                // Circuit Phase Type
                case 'circuit':
                    return null

                // Error Message
                default:
                    console.error(phase.type + ' is not a valid phaseType!!')
            }

            break

        // View Mode
        case 'view':
            switch (phase.type) {
                // Straight Phase Type
                case 'straight':
                    return (
                        <div className="h-10 flex justify-center w-40 border-l px-4 border-stone-400 items-center">
                            <p className="text-center">Sets: {exercise.sets.length}</p>
                        </div>
                    )

                // Circuit Phase Type
                case 'circuit':
                    return null

                // Error Message
                default:
                    console.error(phase.type + ' is not a valid phaseType!!')
            }

            break

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
